"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4853],{

/***/ 19527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CurrencyInputPanel; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(34727);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(48732);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(9941);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(32692);
// EXTERNAL MODULE: ./node_modules/next/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(43038);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@moonbiz/sdk/dist/sdk.esm.js + 58 modules
var sdk_esm = __webpack_require__(64922);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 1 modules
var Button = __webpack_require__(20253);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(65528);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44850);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Metamask.tsx
var Metamask = __webpack_require__(65335);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/utils/wallet.ts + 1 modules
var wallet = __webpack_require__(84695);
// EXTERNAL MODULE: ./src/utils/index.ts + 1 modules
var utils = __webpack_require__(38328);
// EXTERNAL MODULE: ./src/contexts/Localization/index.tsx + 3 modules
var Localization = __webpack_require__(99150);
// EXTERNAL MODULE: ./src/state/types.ts
var types = __webpack_require__(45101);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(64011);
// EXTERNAL MODULE: ./src/hooks/useTokenBalance.ts
var useTokenBalance = __webpack_require__(24319);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(65044);
// EXTERNAL MODULE: ./src/state/satt/hooks.ts
var hooks = __webpack_require__(12049);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/state/farms/hooks.ts + 1 modules
var farms_hooks = __webpack_require__(17166);
// EXTERNAL MODULE: ./src/components/CopyButton/index.tsx
var CopyButton = __webpack_require__(57370);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(44747);
;// CONCATENATED MODULE: ./src/components/CurrencyInputPanel/NumericalInput.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  width: 0;\n  position: relative;\n  font-weight: 500;\n  outline: none;\n  border: none;\n  flex: 1 1 auto;\n  background-color: transparent;\n  font-size: 16px;\n  text-align: ",
        ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding: 0px;\n  -webkit-appearance: textfield;\n\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  [type='number'] {\n    -moz-appearance: textfield;\n  }\n\n  ::-webkit-outer-spin-button,\n  ::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n  }\n\n  ::placeholder {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StyledInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-1c5b2b79-0"
})(_templateObject(), function(param) {
    var error = param.error, theme = param.theme;
    return error ? theme.colors.failure : theme.colors.text;
}, function(param) {
    var align = param.align;
    return align !== null && align !== void 0 ? align : "right";
}, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var inputRegex = RegExp("^\\d*(?:\\\\[.])?\\d*$") // match escaped "." characters via in a non-capturing group
;
var Input = /*#__PURE__*/ (0,react.memo)(function InnerInput(_param) {
    var value = _param.value, onUserInput = _param.onUserInput, placeholder = _param.placeholder, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "value",
        "onUserInput",
        "placeholder"
    ]);
    var enforcer = function(nextUserInput) {
        if (nextUserInput === "" || inputRegex.test((0,utils/* escapeRegExp */.hr)(nextUserInput))) {
            onUserInput(nextUserInput);
        }
    };
    var t = (0,Localization/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInput, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        value: value,
        onChange: function(event) {
            // replace commas with periods, because we exclusively uses period as the decimal separator
            enforcer(event.target.value.replace(/,/g, "."));
        },
        // universal input options
        inputMode: "decimal",
        title: t("Token Amount"),
        autoComplete: "off",
        autoCorrect: "off",
        // text-specific options
        type: "text",
        pattern: "^[0-9]*[.,]?[0-9]*$",
        placeholder: placeholder || "0.0",
        minLength: 1,
        maxLength: 79,
        spellCheck: "false"
    }));
});
/* harmony default export */ var NumericalInput = ((/* unused pure expression or super */ null && (Input)));

// EXTERNAL MODULE: ./src/state/wallet/hooks.ts
var wallet_hooks = __webpack_require__(71900);
// EXTERNAL MODULE: ./src/components/SearchModal/CurrencySearchModal.tsx + 12 modules
var CurrencySearchModal = __webpack_require__(63439);
// EXTERNAL MODULE: ./src/components/Logo/index.ts + 2 modules
var Logo = __webpack_require__(74314);
;// CONCATENATED MODULE: ./src/components/CurrencyInputPanel/index.tsx





function CurrencyInputPanel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: flex-end;\n  padding: ",
        ";\n"
    ]);
    CurrencyInputPanel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 0.5rem;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  color: ",
        ";\n  font-size: 0.75rem;\n  line-height: 1rem;\n  padding: 0.75rem 1rem 0 1rem;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-flow: column nowrap;\n  position: relative;\n  border-radius: 20px;\n  background-color: ",
        ";\n  z-index: 1;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 16px;\n  background-color: ",
        ";\n  box-shadow: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




















var InputRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f2927f-0"
})(CurrencyInputPanel_templateObject(), function(param) {
    var selected = param.selected;
    return selected ? "0.75rem 0.5rem 0.75rem 1rem" : "0.75rem 0.75rem 0.75rem 1rem";
});
var CurrencySelectButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).attrs({
    variant: "text",
    scale: "sm"
}).withConfig({
    componentId: "sc-f2927f-1"
})(_templateObject1());
var LabelRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f2927f-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var InputPanel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f2927f-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
});
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f2927f-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.input;
}, function(param) {
    var theme = param.theme;
    return theme.shadows.inset;
});
function CurrencyInputPanel(param) {
    var value = param.value, onUserInput = param.onUserInput, onMax = param.onMax, showMaxButton = param.showMaxButton, label = param.label, onCurrencySelect = param.onCurrencySelect, currency = param.currency, _disableCurrencySelect = param.disableCurrencySelect, disableCurrencySelect = _disableCurrencySelect === void 0 ? false : _disableCurrencySelect, _hideBalance = param.hideBalance, hideBalance = _hideBalance === void 0 ? false : _hideBalance, _pair = param.pair, pair = _pair === void 0 ? null : _pair, otherCurrency = param.otherCurrency, id = param.id, showCommonBases = param.showCommonBases;
    var ref;
    var ref1 = (0,react.useState)(0), priceCurrency = ref1[0], setPriceCurrency = ref1[1];
    var ref2 = (0,react.useState)(0), dollarApprox = ref2[0], setDollarApprox = ref2[1];
    var ref3 = (0,useActiveWeb3React/* default */.Z)(), account = ref3.account, library = ref3.library;
    var sattAddress = (0,hooks/* useSattWallet */.M)().sattAddress;
    var address = account || sattAddress || undefined;
    var ref4 = (0,useTokenBalance/* useGetBnbBalance */.nu)(), bnbBalance = ref4.balance;
    var selectedCurrencyBalance = (0,wallet_hooks/* useCurrencyBalance */._h)(address, currency !== null && currency !== void 0 ? currency : undefined);
    // const amountInDollar = useBUSDCurrencyAmount(
    //   //  showBUSD ? currency : undefined,
    //   currency,
    //   Number.isFinite(+value) ? +value : undefined,
    // )
    var ref5 = (0,Localization/* useTranslation */.$G)(), t = ref5.t, locale = ref5.currentLanguage.locale;
    var amountInDollars = function(val) {
        setDollarApprox(val * priceCurrency);
    };
    /* eslint-disable */ var fetchCryptoPrice = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var symbol, ref, ref1, ref2, response, price, price1, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        symbol = currency === null || currency === void 0 ? void 0 : currency.symbol;
                        setPriceCurrency(0);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!(symbol !== "RP1" && symbol !== undefined)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            axios_default()({
                                url: "/api/cryptocurrency",
                                method: "GET",
                                headers: {
                                    "X-CMC_PRO_API_KEY": "091586f4-11fe-4c6a-8c2b-059f5e75f7a7",
                                    "Content-Type": "application/json"
                                },
                                params: {
                                    symbol: symbol
                                }
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        price = (ref = response.data.data[symbol]) === null || ref === void 0 ? void 0 : (ref1 = ref.quote) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.USD) === null || ref2 === void 0 ? void 0 : ref2.price;
                        setPriceCurrency(price);
                        amountInDollars(value);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        if (symbol === "RP1") {
                            price1 = (0,farms_hooks/* rp1PriceUsd */.gt)();
                            setPriceCurrency(price1);
                        }
                        _state.label = 4;
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        error = _state.sent();
                        console.error("Error fetching crypto price:", error);
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchCryptoPrice() {
            return _ref.apply(this, arguments);
        };
    }();
    var token = pair ? pair.liquidityToken : (0,_instanceof/* default */.Z)(currency, sdk_esm/* Token */.WU) ? currency : null;
    var tokenAddress = token ? (0,utils/* isAddress */.UJ)(token.address) : null;
    (0,react.useEffect)(function() {
        fetchCryptoPrice();
        amountInDollars(value);
    }, [
        value,
        currency
    ]);
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencySearchModal/* default */.Z, {
        onCurrencySelect: onCurrencySelect,
        selectedCurrency: currency,
        otherSelectedCurrency: otherCurrency,
        showCommonBases: showCommonBases
    })), 1), onPresentCurrencyModal = ref6[0];
    var ref7;
    /* eslint-enable */ return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        position: "relative",
        id: id,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                mb: "6px",
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencySelectButton, {
                                className: "open-currency-select-button",
                                selected: !!currency,
                                onClick: function() {
                                    if (!disableCurrencySelect) {
                                        onPresentCurrencyModal();
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    children: [
                                        pair ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* DoubleCurrencyLogo */.ge, {
                                            currency0: pair.token0,
                                            currency1: pair.token1,
                                            size: 16,
                                            margin: true
                                        }) : currency ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* CurrencyLogo */.Xw, {
                                            currency: currency,
                                            size: "24px",
                                            style: {
                                                marginRight: "8px"
                                            }
                                        }) : null,
                                        pair ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                            id: "pair",
                                            bold: true,
                                            children: [
                                                pair === null || pair === void 0 ? void 0 : pair.token0.symbol,
                                                ":",
                                                pair === null || pair === void 0 ? void 0 : pair.token1.symbol
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            id: "pair",
                                            bold: true,
                                            children: (currency && currency.symbol && currency.symbol.length > 20 ? "".concat(currency.symbol.slice(0, 4), "...").concat(currency.symbol.slice(currency.symbol.length - 5, currency.symbol.length)) : currency === null || currency === void 0 ? void 0 : currency.symbol) || t("Select a currency")
                                        }),
                                        !disableCurrencySelect
                                    ]
                                })
                            }),
                            token && tokenAddress ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                style: {
                                    gap: "4px"
                                },
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyButton/* CopyButton */.q, {
                                        width: "16px",
                                        buttonColor: "textSubtle",
                                        text: tokenAddress,
                                        tooltipMessage: t("Token address copied"),
                                        tooltipTop: -20,
                                        tooltipRight: 40,
                                        tooltipFontSize: 12
                                    }),
                                    (library === null || library === void 0 ? void 0 : (ref = library.provider) === null || ref === void 0 ? void 0 : ref.isMetaMask) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Metamask/* default */.Z, {
                                        style: {
                                            cursor: "pointer"
                                        },
                                        width: "16px",
                                        onClick: function() {
                                            return (0,wallet/* registerToken */.$P)(tokenAddress, token.symbol, token.decimals, (0,_instanceof/* default */.Z)(token, types/* WrappedTokenInfo */.DT) ? token.logoURI : undefined);
                                        }
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    address && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        onClick: onMax,
                        color: "textSubtle",
                        fontSize: "14px",
                        style: {
                            display: "inline",
                            cursor: "pointer",
                            whiteSpace: "nowrap",
                            maxWidth: "120px",
                            textOverflow: "ellipsis",
                            overflow: "hidden"
                        },
                        children: !hideBalance && !!currency ? t("Balance: %balance%", {
                            balance: currency.symbol === "BNB" ? (0,formatBalance/* formatBigNumber */.dp)(bnbBalance, 6) : (ref7 = selectedCurrencyBalance === null || selectedCurrencyBalance === void 0 ? void 0 : selectedCurrencyBalance.toSignificant(6)) !== null && ref7 !== void 0 ? ref7 : t("Loading")
                        }) : " -"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputPanel, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                    as: "label",
                    style: {
                        display: "block"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelRow, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                className: "token-amount-input",
                                value: value,
                                onUserInput: function(val) {
                                    onUserInput(val);
                                }
                            })
                        }),
                        !!currency && value !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            justifyContent: "flex-end",
                            mr: "1rem",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                maxWidth: "200px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    fontSize: "12px",
                                    color: "textSubtle",
                                    children: [
                                        "~",
                                        (0,formatBalance/* formatNumber */.uf)(dollarApprox),
                                        " USD"
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InputRow, {
                            selected: disableCurrencySelect,
                            children: address && currency && showMaxButton && label !== "To" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                onClick: onMax,
                                scale: "xs",
                                variant: "secondary",
                                children: t("Max").toLocaleUpperCase(locale)
                            })
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 19508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _gelatonetwork_limit_orders_lib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55855);
/* harmony import */ var _gelatonetwork_limit_orders_lib__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_gelatonetwork_limit_orders_lib__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64011);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3862);




var useGelatoLimitOrdersLib = function() {
    var ref = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(), chainId = ref.chainId, library = ref.library;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (!chainId || !library) {
            console.error("Could not instantiate GelatoLimitOrders: missing chainId or library");
            return undefined;
        }
        try {
            return new _gelatonetwork_limit_orders_lib__WEBPACK_IMPORTED_MODULE_1__.GelatoLimitOrders(chainId, library === null || library === void 0 ? void 0 : library.getSigner(), config_constants__WEBPACK_IMPORTED_MODULE_3__/* .GELATO_HANDLER */ .uX, false);
        } catch (error) {
            console.error("Could not instantiate GelatoLimitOrders: ".concat(error.message));
            return undefined;
        }
    }, [
        chainId,
        library
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useGelatoLimitOrdersLib);


/***/ }),

/***/ 50165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UK": function() { return /* binding */ ApprovalState; },
  "qL": function() { return /* binding */ useApproveCallback; },
  "tz": function() { return /* binding */ useApproveCallbackFromInputCurrencyAmount; },
  "re": function() { return /* binding */ useApproveCallbackFromTrade; },
  "x": function() { return /* binding */ useApproveCallbackFromTradePancake; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(34727);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(48732);
// EXTERNAL MODULE: ./node_modules/next/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(43038);
// EXTERNAL MODULE: ./node_modules/@ethersproject/constants/lib.esm/bignumbers.js
var bignumbers = __webpack_require__(21046);
// EXTERNAL MODULE: ./node_modules/@moonbiz/sdk/dist/sdk.esm.js + 58 modules
var sdk_esm = __webpack_require__(64922);
// EXTERNAL MODULE: ./src/config/constants/networks.ts
var networks = __webpack_require__(70457);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(64011);
// EXTERNAL MODULE: ./src/utils/sentry.ts
var sentry = __webpack_require__(17226);
// EXTERNAL MODULE: ./src/config/constants/index.ts
var constants = __webpack_require__(3862);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 1 modules
var useContract = __webpack_require__(5039);
// EXTERNAL MODULE: ./src/state/multicall/hooks.ts
var hooks = __webpack_require__(91001);
;// CONCATENATED MODULE: ./src/hooks/useTokenAllowance.ts




function useTokenAllowance(token, owner, spender) {
    var contract = (0,useContract/* useTokenContract */.Ib)(token === null || token === void 0 ? void 0 : token.address, false);
    var inputs = (0,react.useMemo)(function() {
        return [
            owner,
            spender
        ];
    }, [
        owner,
        spender
    ]);
    var allowance = (0,hooks/* useSingleCallResult */.Wk)(contract, "allowance", inputs).result;
    return (0,react.useMemo)(function() {
        return token && allowance ? new sdk_esm/* TokenAmount */.dt(token, allowance.toString()) : undefined;
    }, [
        token,
        allowance
    ]);
}
/* harmony default export */ var hooks_useTokenAllowance = (useTokenAllowance);

// EXTERNAL MODULE: ./src/state/swap/actions.ts
var actions = __webpack_require__(70193);
// EXTERNAL MODULE: ./src/state/transactions/hooks.tsx
var transactions_hooks = __webpack_require__(55892);
// EXTERNAL MODULE: ./src/utils/prices.ts
var prices = __webpack_require__(7879);
// EXTERNAL MODULE: ./src/utils/index.ts + 1 modules
var utils = __webpack_require__(38328);
// EXTERNAL MODULE: ./src/hooks/useCallWithGasPrice.ts
var useCallWithGasPrice = __webpack_require__(71228);
// EXTERNAL MODULE: ./src/hooks/useToast.ts
var useToast = __webpack_require__(789);
// EXTERNAL MODULE: ./src/contexts/Localization/index.tsx + 3 modules
var Localization = __webpack_require__(99150);
// EXTERNAL MODULE: ./src/hooks/limitOrders/useGelatoLimitOrdersLib.ts
var useGelatoLimitOrdersLib = __webpack_require__(19508);
;// CONCATENATED MODULE: ./src/hooks/useApproveCallback.ts




















var ApprovalState;
(function(ApprovalState) {
    ApprovalState[ApprovalState["UNKNOWN"] = 0] = "UNKNOWN";
    ApprovalState[ApprovalState["NOT_APPROVED"] = 1] = "NOT_APPROVED";
    ApprovalState[ApprovalState["PENDING"] = 2] = "PENDING";
    ApprovalState[ApprovalState["APPROVED"] = 3] = "APPROVED";
})(ApprovalState || (ApprovalState = {}));
// returns a variable indicating the state of the approval and a function which approves if necessary or early returns
function useApproveCallback(amountToApprove, spender) {
    var account = (0,useActiveWeb3React/* default */.Z)().account;
    // const { sattAddress, getSattSigner } = useSattWallet()
    var address = account || undefined;
    var callWithGasPrice = (0,useCallWithGasPrice/* useCallWithGasPrice */.d)().callWithGasPrice;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var toastError = (0,useToast/* default */.Z)().toastError;
    var token = (0,_instanceof/* default */.Z)(amountToApprove, sdk_esm/* TokenAmount */.dt) ? amountToApprove.token : undefined;
    var currentAllowance = hooks_useTokenAllowance(token, address !== null && address !== void 0 ? address : undefined, spender);
    var pendingApproval = (0,transactions_hooks/* useHasPendingApproval */.wB)(token === null || token === void 0 ? void 0 : token.address, spender);
    // check the current approval status
    var approvalState = (0,react.useMemo)(function() {
        if (!amountToApprove || !spender) return ApprovalState.UNKNOWN;
        if (amountToApprove.currency === sdk_esm/* ETHER */.c0) return ApprovalState.APPROVED;
        // we might not have enough data to know whether or not we need to approve
        if (!currentAllowance) return ApprovalState.UNKNOWN;
        // amountToApprove will be defined if currentAllowance is
        return currentAllowance.lessThan(amountToApprove) ? pendingApproval ? ApprovalState.PENDING : ApprovalState.NOT_APPROVED : ApprovalState.APPROVED;
    }, [
        amountToApprove,
        currentAllowance,
        pendingApproval,
        spender
    ]);
    var addTransaction = (0,transactions_hooks/* useTransactionAdder */.h7)();
    var tokenContract = (0,useContract/* useTokenContract */.Ib)(token === null || token === void 0 ? void 0 : token.address);
    var tokenContractRef = (0,react.useRef)(tokenContract);
    (0,react.useEffect)(function() {
        tokenContractRef.current = tokenContract;
    }, [
        tokenContract
    ]);
    var approve = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var useExact, estimatedGas;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // if (sattAddress && password) {
                    //   tokenContractRef.current = getContract(token?.address, ERC20_ABI, getSattSigner(password));
                    // }
                    if (approvalState !== ApprovalState.NOT_APPROVED) {
                        toastError(t("Error"), t("Approve was called unnecessarily"));
                        console.error("approve was called unnecessarily");
                        return [
                            2
                        ];
                    }
                    if (!token) {
                        toastError(t("Error"), t("No token"));
                        console.error("no token");
                        return [
                            2
                        ];
                    }
                    if (!tokenContractRef.current) {
                        toastError(t("Error"), t("Cannot find contract of the token %tokenAddress%", {
                            tokenAddress: token === null || token === void 0 ? void 0 : token.address
                        }));
                        console.error("tokenContract is null");
                        return [
                            2
                        ];
                    }
                    if (!amountToApprove) {
                        toastError(t("Error"), t("Missing amount to approve"));
                        console.error("missing amount to approve");
                        return [
                            2
                        ];
                    }
                    if (!spender) {
                        toastError(t("Error"), t("No spender"));
                        console.error("no spender");
                        return [
                            2
                        ];
                    }
                    useExact = false;
                    return [
                        4,
                        tokenContractRef.current.estimateGas.approve(spender, bignumbers/* MaxUint256 */.Bz).catch(function() {
                            // general fallback for tokens who restrict approval amounts
                            useExact = true;
                            return tokenContractRef.current.estimateGas.approve(spender, amountToApprove.raw.toString());
                        })
                    ];
                case 1:
                    estimatedGas = _state.sent();
                    // eslint-disable-next-line consistent-return
                    return [
                        2,
                        callWithGasPrice(tokenContractRef.current, "approve", [
                            spender,
                            useExact ? amountToApprove.raw.toString() : bignumbers/* MaxUint256 */.Bz
                        ], {
                            gasLimit: (0,utils/* calculateGasMargin */.yC)(estimatedGas)
                        }).then(function(response) {
                            addTransaction(response, {
                                summary: "Approve ".concat(amountToApprove.currency.symbol),
                                approval: {
                                    tokenAddress: token.address,
                                    spender: spender
                                }
                            });
                        }).catch(function(error) {
                            (0,sentry/* logError */.H)(error);
                            console.error("Failed to approve token", error);
                            if ((error === null || error === void 0 ? void 0 : error.code) !== 4001) {
                                toastError(t("Error"), error.message);
                            }
                            throw error;
                        })
                    ];
            }
        });
    }), [
        approvalState,
        token,
        tokenContractRef,
        amountToApprove,
        spender,
        addTransaction,
        callWithGasPrice,
        t,
        toastError, 
    ]);
    return [
        approvalState,
        approve
    ];
}
// wraps useApproveCallback in the context of a swap
function useApproveCallbackFromTrade(trade) {
    var allowedSlippage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, routerAddress = arguments.length > 2 ? arguments[2] : void 0;
    var amountToApprove = (0,react.useMemo)(function() {
        return trade ? (0,prices/* computeSlippageAdjustedAmounts */.b5)(trade, allowedSlippage)[actions/* Field.INPUT */.gN.INPUT] : undefined;
    }, [
        trade,
        allowedSlippage
    ]);
    var targetRouterAddress = routerAddress || constants/* ROUTER_ADDRESS */.bR[networks/* CHAIN_ID */.K];
    return useApproveCallback(amountToApprove, targetRouterAddress);
}
function useApproveCallbackFromTradePancake(trade) {
    var allowedSlippage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, routerAddress = arguments.length > 2 ? arguments[2] : void 0;
    var amountToApprove = (0,react.useMemo)(function() {
        return trade ? (0,prices/* computeSlippageAdjustedAmounts */.b5)(trade, allowedSlippage)[actions/* Field.INPUT */.gN.INPUT] : undefined;
    }, [
        trade,
        allowedSlippage
    ]);
    var targetRouterAddress = routerAddress || constants/* ROUTER_ADDRESS_PANCAKE */.L1[networks/* CHAIN_ID */.K];
    return useApproveCallback(amountToApprove, targetRouterAddress);
}
// Wraps useApproveCallback in the context of a Gelato Limit Orders
function useApproveCallbackFromInputCurrencyAmount(currencyAmountIn) {
    var gelatoLibrary = (0,useGelatoLimitOrdersLib/* default */.Z)();
    var _address;
    return useApproveCallback(currencyAmountIn, (_address = gelatoLibrary === null || gelatoLibrary === void 0 ? void 0 : gelatoLibrary.erc20OrderRouter.address) !== null && _address !== void 0 ? _address : undefined);
}


/***/ })

}]);